import Repository from "./Repository";

const CREATE = "add";
const GET = "get";
const UPDATE = "edit";
const DELETE = "delete";

export default {
  createMedicalFaq(payload) {
    return Repository.post(transformRoute(CREATE), payload);
  },
  getMedicalFaq(payload) {
    return Repository.post(transformRoute(GET), payload);
  },
  updateMedicalFaq(payload) {
    return Repository.post(transformRoute(UPDATE), payload);
  },
  deleteMedicalFaq(payload) {
    return Repository.post(transformRoute(DELETE), payload);
  },
};

const transformRoute = (route) => {
  return `/medical_faq/${route}`;
};
